import { DriverContactInfoParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchContactDriverData/patchContactDriverQuery.type';
import { driverContactQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchContactDriverData/patchContactDriverQueryFunctions';
import { useMutation } from '@tanstack/react-query';

export const useDriverContactQuery = () => {
  return useMutation({
    mutationFn: (params: DriverContactInfoParamsType) =>
      driverContactQueryFunction(params),
    mutationKey: ['driverContactQuery'],
  });
};
